import './myMhBanner.scss';

import React from 'react';

import Logo from './Splash Screen Logo.svg?react';

const MyMhBanner = () => {
  return (
    <div className='mymh-banner'>
      <Logo className='mymh-logo' aria-label='My Memorial Hermann' />
    </div>
  );
};

export default MyMhBanner;
